import React from 'react'
import { Link } from "react-router-dom";


const HomeGallery = () => {
    return (
        <>

            <div className="gallery-section m-2 mt-0 mb-0 fix" style={{ marginTop: "-90px" }}>
                <div className="item-bg">
                    <img src="assets/img/gallery/Gallery-bg.png" alt="bg-image" />
                </div>
                <div className="item-bg-2">
                    <img src="assets/img/gallery/Gallery-bg.png" alt="bg-image" />
                </div>
                <div className="gallery-wrapper">
                    <div className="row g-2">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                            <div className="gallery-image wow flipInY" data-wow-delay=".9s" style={{ visibility: 'visible', animationDelay: '0.9s', animationName: 'flipInY' }}>
                                <a to="assets/img/gallery/gallery-1.jpg" className="img-popup">
                                    <img src="assets/img/gallery/gallery-1.jpg" alt="img" />
                                    {/* <div className="icon">
                                        <i className="fal fa-plus" />
                                    </div> */}
                                </a>
                            </div>
                            <div className="gallery-image mt-2 wow flipInY" data-wow-delay=".9s" style={{ visibility: 'visible', animationDelay: '0.9s', animationName: 'flipInY' }}>
                                <a to="assets/img/gallery/gallery-2.jpg" className="img-popup">
                                    <img src="assets/img/gallery/gallery-2.jpg" alt="img" />
                                    {/* <div className="icon">
                                        <i className="fal fa-plus" />
                                    </div> */}
                                </a>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                            <div className="gallery-image image-2 wow flipInY" data-wow-delay=".9s" style={{ visibility: 'visible', animationDelay: '0.9s', animationName: 'flipInY' }}>
                                <a to="assets/img/gallery/gallery-3.jpg" className="img-popup">
                                    <img src="assets/img/gallery/gallery-3.jpg" alt="img" />
                                    {/* <div className="icon">
                                        <i className="fal fa-plus" />
                                    </div> */}
                                </a>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                            <div className="gallery-image wow flipInY" data-wow-delay=".9s" style={{ visibility: 'visible', animationDelay: '0.9s', animationName: 'flipInY' }}>
                                <a to="assets/img/gallery/gallery-4.jpg" className="img-popup">
                                    <img src="assets/img/gallery/gallery-4.jpg" alt="img" />
                                    {/* <div className="icon">
                                        <i className="fal fa-plus" />
                                    </div> */}
                                </a>
                            </div>
                            <div className="gallery-image mt-2 wow flipInY" data-wow-delay=".9s" style={{ visibility: 'visible', animationDelay: '0.9s', animationName: 'flipInY' }}>
                                <a to="assets/img/gallery/gallery-5.jpg" className="img-popup">
                                    <img src="assets/img/gallery/gallery-5.jpg" alt="img" />
                                    {/* <div className="icon">
                                        <i className="fal fa-plus" />
                                    </div> */}
                                </a>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                            <div className="gallery-image wow flipInY" data-wow-delay=".9s" style={{ visibility: 'visible', animationDelay: '0.9s', animationName: 'flipInY' }}>
                                <a to="assets/img/gallery/gallery-6.jpg" className="img-popup">
                                    <img src="assets/img/gallery/gallery-6.jpg" alt="img" />
                                    {/* <div className="icon">
                                        <i className="fal fa-plus" />
                                    </div> */}
                                </a>
                            </div>
                            <div className="gallery-image mt-2 wow flipInY" data-wow-delay=".9s" style={{ visibility: 'visible', animationDelay: '0.9s', animationName: 'flipInY' }}>
                                <a to="assets/img/gallery/gallery-7.jpg" className="img-popup">
                                    <img src="assets/img/gallery/gallery-7.jpg" alt="img" />
                                    {/* <div className="icon">
                                        <i className="fal fa-plus" />
                                    </div> */}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default HomeGallery